module.exports = __webpack_public_path__ + "static/media/Dawn Schieferdecker Headshot_1686941193094.8f9d7c6e.png";